import { render, staticRenderFns } from "./DocumentDetailTagPicker.vue?vue&type=template&id=95dfd8fc&"
import script from "./DocumentDetailTagPicker.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetailTagPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports